import React, { useState, useEffect, useCallback } from 'react'
import './Header.css'

export const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false)

  const toggleMenu = () => {
    setMenuOpen(!menuOpen)
  }

  const closeMenu = React.useCallback((e) => {
    if (!e.target.closest('.menu-item') && !e.target.closest('.menu-button')) {
      setMenuOpen(false)
    }
  }, [])

  useEffect(() => {
    document.addEventListener('click', closeMenu)
    return () => {
      document.removeEventListener('click', closeMenu)
    }
  }, [])

  const handleMenuItemClick = () => {
    setMenuOpen(false)
  }

  return (
    <header>
        <h1 className='nav-logo'>Sakamo arc.</h1>
        <button onClick={toggleMenu} className="menu-button">
          <span></span><span></span><span></span>
        </button>
        <nav className={`menu-modal ${menuOpen ? 'open' : ''}`}>
            <ul className='menu'>
                <li className='menu-item'><a href="#home" onClick={handleMenuItemClick}>Home</a></li>
                <li className='menu-item'><a href="#about" onClick={handleMenuItemClick}>About</a></li>
                <li className='menu-item'><a href="#skills" onClick={handleMenuItemClick}>Skills</a></li>
                <li className='menu-item'><a href="#works" onClick={handleMenuItemClick}>Works</a></li>
                <li className='menu-item'><a href="#contact" onClick={handleMenuItemClick}>Contact</a></li>
            </ul>
        </nav>
    </header>
  )

}
export default Header